module.exports = __webpack_public_path__ + "static/media/bumppyloginpageimgthree.67768846.png";